import React from 'react';
import { FormattedMessage } from 'react-intl';

import theme from './WaitConnectionPlaceholder.scss';


const WaitConnectionPlaceholder = () => (
  <div className={ theme.root }>
    <FormattedMessage id="const.pleaseWait" defaultMessage="** Please wait..." />
    <div className={ theme.loaderAnimation } />
  </div>
);

export default WaitConnectionPlaceholder;
